<template>
  <div>
    <v-list-item three-line>
      <v-list-item-avatar :class="'avatar__center'">
        <v-img v-if="creator" :src="creator.photo"></v-img>
        <v-icon
            v-else
            :class="`${tran.class}--text`"
        >
          {{tran.icon}}
        </v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title :class="`${tran.class}--text`">
          {{item.amount > 0 ? '+' : ''}}{{item.amount | number}} {{ccy}}
        </v-list-item-title>
        <v-list-item-subtitle>
          <b>Операция #{{item.number}} от {{item.tsCreated | localizedDateShort}}</b><span v-if="creator">: {{creator.fullName}}</span>
        </v-list-item-subtitle>
        <v-list-item-subtitle>
          <p v-if="buyout">
            <b>Закупка "{{buyout.title}}"</b><span v-if="item.isRefundOutOfStock">, возврат за непришедшие</span>
          </p>
          <p v-if="item.status === statuses.reject.id">
            Запрос на погашение долга организатора перед клиентом был отклонен
          </p>
          <p>
            {{item.note}}
          </p>
        </v-list-item-subtitle>
        <v-list-item-subtitle :class="'balances__info'" v-if="item.status !== statuses.reject.id">
          <span>{{ Number.isInteger(item.balanceBefore) ? item.balanceBefore : item.balanceBefore.toFixed(2) }}</span><v-icon>mdi-arrow-right-thin</v-icon><span>{{ Number.isInteger(item.amount + item.balanceBefore) ? item.amount + item.balanceBefore : (item.amount + item.balanceBefore).toFixed(2) }}</span>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-divider inset></v-divider>
  </div>
</template>

<script>
import {status} from '@/constants'

export default {
  name: 'BalanceOperationListItem',
  computed: {
    tran () {
      const t = Object.assign({}, status.transaction[this.item.status])
      if (this.item.status !== status.transaction.done.id) {
        return t
      }
      if (this.item.amount === 0) {
        t.icon = 'mdi-numeric-0'
        t.class = 'gray'
      } else if (this.item.amount < 0) {
        t.icon = 'mdi-minus'
        t.class = 'red'
      }
      return t
    }
  },
  data () {
    return {
      statuses: status.transaction
    }
  },
  props: {
    buyout: {
      type: Object
    },
    ccy: {
      required: true,
      type: String
    },
    creator: {
      type: Object
    },
    divider: {
      type: Boolean
    },
    item: {
      required: true,
      type: Object
    }
  }
}
</script>

<style scoped>
p {
  margin-bottom: 2px;
}
div.reject {
  text-decoration: line-through;
}
.avatar__center {
  align-self: center;
}
.balances__info {
  display: flex;
  align-items: center;
  column-gap: 8px;
}
</style>